import React, { useState } from "react";
import { FormCalculator } from "../../components/form-calculator";
import { GeneralInformation } from "../../components/general-information";
import { Header } from "../../components/header";
import { MainSection } from "../../components/main/MainSection";
import {
  PartsList,
  PartsListStructure,
} from "../../components/parts-list-structure";
import { PartsListIrrigation } from "../../components/parts-list-irrigation";
import "../calculator/global.css";
import { PartsListFixation } from "../../components/parts-list-fixation";
import { LanguageSelector } from "../../components/language-selector";

export const Calculator = () => {
  const [language, setLanguage] = useState("pt-br");

  const [formType, setFormType] = useState("wallgreen");

  const [calculatorDataResult, setCalculatorDataResult] = useState();

  const handleDataCalculator = (data) => {
    setCalculatorDataResult(data);
  };

  const handleTypeChange = (type) => {
    setFormType(type);
  };

  const handleLanguageChange = (language) => {
    setLanguage(language);
  };

  return (
    <>
      <LanguageSelector
        handleLanguageChange={handleLanguageChange}
        language={language}
      />
      <Header changeFormType={handleTypeChange} />
      <MainSection>
        <FormCalculator
          formType={formType}
          setCalculatorDataResult={handleDataCalculator}
          language={language}
        />
        <GeneralInformation
          systemType={formType}
          calculatorDataResult={calculatorDataResult}
          language={language}
        />
        <PartsListStructure
          calculatorDataResult={calculatorDataResult}
          systemType={formType}
          language={language}
        />
        <PartsListIrrigation
          calculatorDataResult={calculatorDataResult}
          systemType={formType}
          language={language}
        />
        <PartsListFixation
          calculatorDataResult={calculatorDataResult}
          systemType={formType}
          language={language}
        />
      </MainSection>
    </>
  );
};
